import { Box, FlexBox } from '@ardoq/layout';
import { NamedEntity } from '@ardoq/api-types';
import { TextInput } from '@ardoq/forms';
import { PrimaryButton } from '@ardoq/button';
import { useState } from 'react';
import { type I18nLocale, t } from '@ardoq/i18n';
import {
  createAssetFolder,
  createAssetFolderFailed,
  createAssetFolderSucceeded,
} from '../../streams/assetFolders/actions';
import { dispatchActionAndWaitForResponse } from '../../actions/utils';

export const NewFolderRow = ({
  selectedFolder,
  setSelectedFolder,
  onFolderCreated,
  i18nLocale,
}: {
  selectedFolder: NamedEntity | null;
  setSelectedFolder: (folder: NamedEntity | null) => void;
  onFolderCreated: (parentFolderId: string | null) => void;
  i18nLocale: I18nLocale;
}) => {
  const [newFolderName, setNewFolderName] = useState<string>('');
  return (
    <Box paddingLeft="xlarge" paddingBottom="small">
      <FlexBox gap="small" flexWrap>
        <TextInput
          placeholder={t(
            i18nLocale,
            'folderSelectDialog:enterFolderName',
            'Enter folder name'
          )}
          onChange={e => setNewFolderName(e.target.value)}
          value={newFolderName}
        />
        <PrimaryButton
          type={'button'}
          isDisabled={newFolderName.length === 0}
          onClick={async () => {
            const newFolder = (
              await dispatchActionAndWaitForResponse(
                createAssetFolder({
                  name: newFolderName,
                  targetFolderId: selectedFolder && selectedFolder._id,
                }),
                createAssetFolderSucceeded,
                createAssetFolderFailed
              )
            ).payload;
            if (!newFolder) {
              return;
            }
            setSelectedFolder({ name: newFolder.name, _id: newFolder._id });
            onFolderCreated(selectedFolder?._id ?? null);
            setNewFolderName('');
          }}
        >
          {selectedFolder
            ? t(
                i18nLocale,
                'folderSelectDialog:createInSelectedFolder',
                'Create in selected folder'
              )
            : t(
                i18nLocale,
                'folderSelectDialog:createAtRootLevel',
                'Create at root level'
              )}
        </PrimaryButton>
      </FlexBox>
    </Box>
  );
};
